// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style__navigation___5ysKy {\n  padding-right: 0px\n}\n.style__navigation___5ysKy a  {\n    margin-right: 0px ! important;\n  }", ""]);
// Exports
exports.locals = {
	"navigation": "style__navigation___5ysKy"
};
module.exports = exports;
